export const isNotEmptyMessage = (message: string) => {
  if (!message) return false;
  return message.trim() !== "";
};
